import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Routes, Route, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react'
import _ from 'lodash'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'

// Pages
import { NotFound } from '../NotFound'

// Components
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { NavBar } from '../../components/NavBar'
import { PrivateRoute } from '../../components/PrivateRoute'
import { PublicRoute } from '../../components/PublicRoute'
import { StateContainer } from '../../components/StateContainer'
import { TaskProgress } from '../../components/TaskProgress'

// Stores
import { UserStoreContext } from '../../stores/UserStore'

// Routes
import routes from './RouteConfig'

/**
 *
 * Routes
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */
const PageRoutes = observer(() => {
  // Context
  const { accessToken, error, getUpdatedUser, isAuthenticated, isEEUser, user } =
    useContext(UserStoreContext)
  const location = useLocation()

  useEffect(() => {
    if (!user && isAuthenticated) {
      const decoded = jwt_decode(accessToken)
      getUpdatedUser(decoded.user_id, true)
    }
  }, [])

  return (
    <div className="relative h-screen w-screen">
      <StateContainer error={error} loading={isAuthenticated && isEEUser === null}>
        <Helmet titleTemplate="%s - Executivevents Portal" defaultTitle="Executivevents Portal">
          <meta name="description" content="Executivevents Portal" />
        </Helmet>

        <NavBar>
          {/* Keeps a page crash inside the page, with the nav still usable. Navigating away
          clears it. */}
          <ErrorBoundary name="routes" resetKey={location.pathname}>
            <Routes>
              {/* Main Routes */}
              <Route key="not-found" path="*" element={<NotFound />} />

              {_.map(routes, (route) => {
                if (route.type === 'custom') {
                  return <Route key={route.path} element={<route.page />} path={route.path} />
                }

                // Pages org users must not reach even by typing the URL. Rendering NotFound rather
                // than redirecting avoids confirming the page exists.
                //
                // Only applies once we know who they are: an unauthenticated visitor is not an EE
                // user either, and must still fall through to PrivateRoute so they get sent to
                // /login rather than a dead end.
                if (route.eeOnly && isAuthenticated && !isEEUser) {
                  return (
                    <Route
                      key={route.path}
                      element={<NotFound />}
                      caseSensitive
                      path={route.path}
                    />
                  )
                }

                const element =
                  route.type === 'public' ? (
                    <PublicRoute component={route.page} />
                  ) : (
                    <PrivateRoute component={route.page} />
                  )

                return <Route key={route.path} element={element} caseSensitive path={route.path} />
              })}
            </Routes>
          </ErrorBoundary>
        </NavBar>
      </StateContainer>

      <TaskProgress />
    </div>
  )
})

export default PageRoutes
